export default "__VITE_ASSET__Cz6Q0q2u__"